const $ = jQuery;

// import * as News from './views/News';
import * as Events from './views/Events';

// import 'jquery-modal';

$(function() {

    let $body = $('body');

    /**
     * Apply filters on the events archive
     */
    if ($body.hasClass('post-type-archive-event')) {
        let $form = $('.event-filters .filter form');

        Events.setPageScrollPosition('.event-content');

        if ($form.length) {
            Events.setForm($form);
            Events.bindCategoryFilters('.apply-filters');
            Events.bindDateFilter('#event-date');
            Events.bindMobileFilter('.mobile-trigger');
        }
    }

    /**
     * Modal across website.
     */
    if($('.modal').length) {
        $(".open-modal").on('click', function(){
            $(this).modal({
                fadeDuration: 250
            });
            return false;
        });
    };

    /**
     * FAQs
     */
    if ($('.faq').length) {
        $('.faq-item h3').click(function(e) {
            var answer = $(this).next();
            if ($(this).hasClass("hide-menu")) {
                answer.slideDown({
                    queue: false
                });
                answer.animate({
                    opacity: 1
                }, {
                    queue: false
                });
                $(this).removeClass('hide-menu');
                $(this).addClass('show-menu');
            } else {
                answer.slideUp({
                    queue: false
                });
                answer.animate({
                    opacity: 0
                }, {
                    queue: false
                });
                $(this).removeClass('show-menu');
                $(this).addClass('hide-menu');
            };
        });
    };

    $(document).on('click', '.hash-link', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });    

    /**
     * Run masonry on the news posts page.
    */
    if ($body.hasClass('blog')) {

        var posts = $('.news-posts').imagesLoaded(function(){
            $('.news-posts').masonry({
              itemSelector: '.info-box',
              percentPosition: true,
              gutter: 30,
            });

            $('.news-posts').css('visibility', 'visible');

        })
    }

    /**
     * Run masonry on press page
     */
    if ($body.hasClass('post-type-archive-press')) {

        var posts = $('.news-posts').imagesLoaded(function(){
            $('.news-posts').masonry({
              itemSelector: '.info-box',
              percentPosition: true,
              gutter: 30,
            });
        })
    }

    /*
        Sticky sidebar
     */
    if ($body.hasClass('single-event')) {
        if ($(window).width() > 767) {
            var sidebar = new StickySidebar('.sidebar-container', {
                topSpacing: 50,
                bottomSpacing: 0,
                resizeSensor: true,
                containerSelector: '.event-container .container',
                innerWrapperSelector: '.event-sidebar'
            });
        }
    }
});


/**
 * After page load functions
 */
$(window).load(function(){

    let $body = $('body');

    if ($body.hasClass('home')) {
        /**
         * Page load animations
         */
        $body.addClass('page-loaded');
    };

    if ($body.hasClass("single-event")) {

      $('.sponsor-button').on('click', function(){
        var sponsorLevel = $(this).data('sponsorlevel');
        $('#nf-field-23').val(sponsorLevel);

        $([document.documentElement, document.body]).animate({
            scrollTop: $(".subscription-form").offset().top
        }, 1000);        
      })
    }

});



// WEBPACK FOOTER //
// ./resources/assets/js/router.js